module.exports = __webpack_public_path__ + "static/img/title-banner1-type4.9814a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3/title-banner1-type4.png
// module id = PBLB
// module chunks = 1